// For the duration and number of events.
var SEND_BATCHES_EVENT = 'HttpManager:_sendBatches';
// For the time taken by privacy guard to process the event.
var PRIVACY_GUARD_PROCESSING_TIME_EVENT = 'PrivacyGuard:_processTelemetry';
var PerfEvent = /** @class */ (function () {
    function PerfEvent(name, payload, isAsync) {
        this.start = Date.now();
        this.name = name;
        this.isAsync = isAsync === true ? true : false;
        this.payload = payload;
    }
    /**
     * Identifies whether this event is a child event of a parent
     */
    PerfEvent.prototype.isChildEvt = function () {
        return false;
    };
    PerfEvent.prototype.complete = function () {
        this.time = Date.now() - this.start;
        this.exTime = this.time;
    };
    return PerfEvent;
}());
export { PerfEvent };
var PerfManager = /** @class */ (function () {
    function PerfManager(callbacks) {
        this._callbacks = callbacks;
    }
    PerfManager.prototype.create = function (src, payload, isAsync) {
        if (src === SEND_BATCHES_EVENT || src === PRIVACY_GUARD_PROCESSING_TIME_EVENT) {
            var evt = new PerfEvent(src, payload, isAsync);
            return evt;
        }
        return null;
    };
    PerfManager.prototype.fire = function (perfEvent) {
        if (perfEvent) {
            perfEvent.complete();
        }
        if (this._callbacks) {
            switch (perfEvent.name) {
                case SEND_BATCHES_EVENT:
                    this.handleSendBatches(perfEvent);
                    break;
                case PRIVACY_GUARD_PROCESSING_TIME_EVENT:
                    this.handlePrivacyGuardNotification(perfEvent);
                    break;
            }
        }
    };
    PerfManager.prototype.setCtx = function (_key, _value) { };
    PerfManager.prototype.getCtx = function (_key) { };
    PerfManager.prototype.handleSendBatches = function (perfEvent) {
        if (this._callbacks.requestProcessingStats) {
            var eventCount = 0;
            if (perfEvent.payload) {
                var payload = perfEvent.payload();
                if (payload.batches) {
                    for (var index in payload.batches) {
                        eventCount += payload.batches[index].evts.length;
                    }
                }
            }
            this._callbacks.requestProcessingStats(perfEvent.time || 0, eventCount);
        }
    };
    PerfManager.prototype.handlePrivacyGuardNotification = function (perfEvent) {
        if (this._callbacks.privacyGuardStats && perfEvent.time && perfEvent.time > 0) {
            this._callbacks.privacyGuardStats(perfEvent.time);
        }
    };
    return PerfManager;
}());
export { PerfManager };
//# sourceMappingURL=PerfManager.js.map